import * as appShellClient from '@springboard/app-shell-client';
import { isEmbedded } from "@/utils/Utils";
import type { Store } from 'vuex';

export const anaplanTokenRefreshService = (store: Store<unknown>) => {
  store.subscribe(()=> {
    if (!isEmbedded()) return;
    appShellClient.refreshAuthToken().catch(console.error);
  });
};